import React from "react";
import CustomCard from "../../shared/Card/CustomCard";
import EnquiryForm from "./EnquiryForm";

export default function ViewEnquiry({ name }) {
    return (
        <CustomCard title={name}>
            <EnquiryForm type="VIEW" />
        </CustomCard>
    );
}
